import { FC, useState } from "react";
import styles from "./LinkItem.module.scss";
import {
  BinIcon,
  DoubleWayArrow,
  getIcon,
  iconNames,
  PenIcon,
} from "../../../assets/icons";

export interface LinkItemContentProps {
  titleHeader?: string;
  title?: string;
  IconRender?: FC;
  iconName?: iconNames;
}

export type LinkItemContentViewProps = LinkItemContentProps & {
  variant?: "dark" | "light";
};

export interface LinkItemListProps {
  variant?: "dark" | "light";
  content?: [LinkItemContentProps, LinkItemContentProps];

  contentRender?: [FC, FC];
  onClick?: () => void;
  handleDelete?: () => void;
  handleEdit?: () => void;
}

export const LinkItemContent = ({
  titleHeader,
  title,
  IconRender,
  iconName,
  variant,
}: LinkItemContentViewProps) => {
  return (
    <div
      className={[styles["link-item"], styles["link-item--" + variant]].join(
        " "
      )}
    >
      {(iconName || IconRender) && (
        <div className={styles["link-item__icon"]}>
          {IconRender && <IconRender />}
          {iconName &&
            getIcon(iconName, {
              color: variant === "dark" ? "white" : "black",
            })}
        </div>
      )}

      <div className={styles["link-item__text-content"]}>
        <div
          className={[
            styles["link-item__text-content__title-header"],
            styles["link-item__text-content__title-header--" + variant],
          ].join(" ")}
        >
          {titleHeader}
        </div>
        <div className={styles["link-item__text-content__title"]}>{title}</div>
      </div>
    </div>
  );
};
export default function LinkItem({
  variant = "light",
  content,
  onClick,
  contentRender,
  handleDelete,
  handleEdit,
}: LinkItemListProps) {
  const ContentRender1 = contentRender?.[0];
  const ContentRender2 = contentRender?.[1];

  return (
    <div className={[styles["global-container"]].join(" ")}>
      <div
        className={[
          styles["link-container"],
          styles["link-container--" + variant],
          onClick ? ( styles["link-container--clickable"], styles["link-container--clickable--" + variant]  ) : "",
          handleDelete || handleEdit || onClick
            ? (styles["link-container--with-hover"],
              styles["link-container--with-hover--" + variant])
            : "",
        ].join(" ")}
        onClick={onClick}
      >
        {content?.[0] && <LinkItemContent {...content[0]} variant={variant} />}
        {ContentRender1 && <ContentRender1 />}
        <DoubleWayArrow color={variant === "dark" ? "white" : "black"} />
        {content?.[1] && <LinkItemContent {...content[1]} variant={variant} />}
        {ContentRender2 && <ContentRender2 />}
      </div>
      {(handleDelete || handleEdit) && (
        <div className={[styles["global-container__btn-container"]].join(" ")}>
          <BtnModule
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            variant={variant}
          />
        </div>
      )}
    </div>
  );
}

export const BtnModule = ({
  handleDelete,
  handleEdit,
  variant,
}: {
  handleDelete?: () => void;
  handleEdit?: () => void;
  variant?: "dark" | "light";
}) => {
  const [isHoverDelete, setHoverDelete] = useState<boolean>(false);
  const [isHoverEdit, setHoverEdit] = useState<boolean>(false);
  return (
    <div
      className={[styles["btn-module"], styles["btn-module--" + variant]].join(
        " "
      )}
    >
      {handleEdit && (
        <button
          className={[
            styles["btn-module__btn--edit"],
            styles["btn-module__btn"],
          ].join(" ")}
          onClick={handleEdit}
          onMouseEnter={() => setHoverEdit(true)}
          onMouseLeave={() => setHoverEdit(false)}
        >
          <PenIcon color={!isHoverEdit ? "white" : "#70c0fd"} size={18} />
        </button>
      )}
      {handleDelete && (
        <button
          className={[
            styles["btn-module__btn--delete"],
            styles["btn-module__btn"],
          ].join(" ")}
          onClick={handleDelete}
          onMouseEnter={() => setHoverDelete(true)}
          onMouseLeave={() => setHoverDelete(false)}
        >
          <BinIcon color={!isHoverDelete ? "white" : "#ff6f6f"} size={17} />
        </button>
      )}
    </div>
  );
};
